import axios from "axios";
import { API_URL } from "const/constants";

const BASE = `${API_URL}/referral-support-tickets`;
const unwrap = (data) => data?.data ?? data;

export const SUPPORT_KEY = ["referral-support"];

export const listSupportTickets = async (params) =>
  unwrap((await axios.get(BASE, { params })).data);

export const officeTicketApi = {
  fetchDetail: async (ticketId) => unwrap((await axios.get(`${BASE}/${ticketId}`)).data),
  fetchEntries: async (ticketId, params) =>
    unwrap((await axios.get(`${BASE}/${ticketId}/entries`, { params })).data),
  reply: async (ticketId, formData) =>
    unwrap((await axios.post(`${BASE}/${ticketId}/entries`, formData)).data),
  changeStatus: async (ticketId, payload) =>
    unwrap((await axios.post(`${BASE}/${ticketId}/status`, payload)).data),
  markRead: async (ticketId) => unwrap((await axios.post(`${BASE}/${ticketId}/read`)).data),
};

export const supportTicketPath = (ticket) => `/admin/admin-referral/support/${ticket.id}`;
